/**
 * WeightFooter.jsx
 * ────────────────
 * Sticky footer for the Loading Screen showing weight status,
 * progress bar, tool count, and Review BOL button.
 */

import React from 'react';
import './WeightFooter.css';

function getThresholdColor(pct) {
  if (pct >= 95) return 'var(--bar-red)';
  if (pct >= 80) return 'var(--bar-amber)';
  return 'var(--bar-green)';
}

export default function WeightFooter({
  loadedWeightLbs,
  advisoryWeightLbs,
  toolCount,
  onReviewBol,
  reviewBolDisabled,
  actionLabel = 'Review BOL',
}) {
  const remaining = advisoryWeightLbs - loadedWeightLbs;
  const pct = advisoryWeightLbs > 0 ? (loadedWeightLbs / advisoryWeightLbs) * 100 : 0;
  const barWidth = Math.min(pct, 100);
  const thresholdColor = getThresholdColor(pct);

  return (
    <div className="wf-footer">
      {/* Row 1: Weight display */}
      <div className="wf-weight-row">
        <div className="wf-loaded">
          <span className="wf-loaded-value" style={{ color: thresholdColor }}>
            {loadedWeightLbs.toLocaleString()}
          </span>
          <span className="wf-loaded-unit">lbs loaded</span>
        </div>
        <div className="wf-remaining">
          {remaining >= 0 ? (
            <>
              <span className="wf-remaining-value">{remaining.toLocaleString()}</span>
              <span className="wf-remaining-unit">lbs remaining</span>
            </>
          ) : (
            <span className="wf-over-limit">OVER LIMIT</span>
          )}
        </div>
      </div>

      {/* Row 2: Progress bar */}
      <div className="wf-progress-track">
        <div
          className="wf-progress-fill"
          style={{ width: `${barWidth}%`, background: thresholdColor }}
        />
      </div>

      {/* Row 3: Tool count + Review BOL */}
      <div className="wf-action-row">
        <span className="wf-tool-count">
          {toolCount} tool{toolCount !== 1 ? 's' : ''} loaded
        </span>
        <button
          className="wf-review-btn"
          onClick={onReviewBol}
          disabled={reviewBolDisabled}
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
}
